import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_23: FaireProductEntity = {
  token: "starter_collection_23",
  type: "product",
  name: "Alive Extra Virgin Olive Oil",
  brandName: "Brightland",
  imageUrl: "",
  priceDollars: 37,
  msrpDollars: 74,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
